export enum MaterialControlType {
  CONTROL_UNKNOWN = 'mat:unknown',

  // controls for group or subset model:
  CONTROL_DIVISION = 'mat:division',
  CONTROL_FIELDSET = 'mat:fieldset',
  CONTROL_TABGROUP = 'mat:tabgroup',
  CONTROL_STEPPER = 'mat:stepper',

  // controls for array model:
  CONTROL_ARRAY = 'mat:array',

  // controls for value model:
  CONTROL_CHECKBOX = 'mat:checkbox',
  CONTROL_INPUT = 'mat:input',
  CONTROL_RADIOGROUP = 'mat:radiogroup',
  CONTROL_SELECT = 'mat:select',
  CONTROL_SLIDER = 'mat:slider',
  CONTROL_SWITCH = 'mat:switch',
  CONTROL_TEXTAREA = 'mat:textarea',
  CONTROL_DATEPICKER = 'mat:datepicker',
  CONTROL_TIMEPICKER = 'mat:timepicker',
  CONTROL_LISTPICKER = 'mat:listpicker',
  CONTROL_UPLOAD = 'mat:upload',

  // controls for null model:
  CONTROL_BUTTON = 'mat:button',
  CONTROL_SEPARATOR = 'mat:separator',
}
